const V1 = "/api/v1/website";
const PUBLIC_V1 = "/api/v1";

export const ENDPOINTS = {
    AUTH: {
        REGISTER: `${V1}/auth/register`,
        LOGIN: `${V1}/auth/login`,
        LOGOUT: `${V1}/auth/logout`,
        REFRESH: `${V1}/auth/refresh`,
        FORGOT_PASSWORD: `${V1}/auth/forgot-password`,
        RESET_PASSWORD: `${V1}/auth/reset-password`,
        VERIFY_SESSION: `${V1}/auth/verify-session`,
    },
    PROFILE: {
        GET: `${V1}/profile`,
        UPDATE: `${V1}/profile`,
        CHANGE_PASSWORD: `${V1}/profile/password`,
    },
    ADDRESSES: {
        LIST: `${V1}/addresses`,
        CREATE: `${V1}/addresses`,
        UPDATE: (id) => `${V1}/addresses/${id}`,
        DELETE: (id) => `${V1}/addresses/${id}`,
        SET_DEFAULT: (id) => `${V1}/addresses/${id}/set-default`,
    },
    PRODUCTS: {
        LIST: `${V1}/products`,
        BY_SLUG: (slug) => `${V1}/products/${slug}`,
        BY_CATEGORY: (slug) => `${V1}/products/category/${slug}`,
        BY_BRAND: (slug) => `${V1}/products/brand/${slug}`,
        BOUGHT_TOGETHER: `${PUBLIC_V1}/products/bought-together`,
    },
    RECOMMENDATIONS: {
        CART: `${V1}/recommendations/cart`,
        USER: `${V1}/recommendations/user`,
    },
    ACCESSORIES: {
        HOME: `${V1}/accessories/home`,
    },
    FREE_GIFT: {
        ELIGIBLE: `${V1}/free-gift/eligible`,
        SELECT: `${V1}/free-gift/select`,
        REMOVE: (variantId) => `${V1}/free-gift/${variantId}`,
    },
    CART: {
        GET: `${V1}/cart`,
        ADD_ITEM: `${V1}/cart/items`,
        UPDATE_ITEM: (variantId) => `${V1}/cart/items/${variantId}`,
        REMOVE_ITEM: (variantId) => `${V1}/cart/items/${variantId}`,
        CLEAR: `${V1}/cart`,
        VALIDATE: `${V1}/cart/validate`,
    },
    COUPON: {
        VALIDATE: `${V1}/coupon/validate`,
        APPLY: `${V1}/coupon/apply`,
        REMOVE: `${V1}/coupon/remove`,
    },
    WISHLIST: {
        LIST: `${V1}/wishlist`,
        ADD: `${V1}/wishlist`,
        REMOVE: (variantId) => `${V1}/wishlist/${variantId}`,
        MOVE_TO_CART: (variantId) => `${V1}/wishlist/${variantId}/move-to-cart`,
    },
    CHECKOUT: {
        INITIATE: `${V1}/checkout/initiate`,
        APPLY_STORE_CREDIT: `${V1}/checkout/apply-store-credit`,
    },
    ORDERS: {
        LIST: `${V1}/orders`,
        DETAIL: (orderNumber) => `${V1}/orders/${orderNumber}`,
        CANCEL: (orderNumber) => `${V1}/orders/${orderNumber}/cancel`,
        RETURN: (orderNumber) => `${V1}/orders/${orderNumber}/return`,
        INVOICE: (orderNumber) => `${V1}/orders/${orderNumber}/invoice`,
        TRACK: (token) => `${V1}/orders/track/${token}`,
        RETURN_REASONS: `${V1}/return-reasons`,
    },
    PAYMENTS: {
        INITIATE_MPESA: `${V1}/payments/mpesa/initiate`,
        MPESA_STATUS: (orderId) => `${V1}/payments/mpesa/status/${orderId}`,
    },
    SUPPORT: {
        LIST: `${V1}/support/tickets`,
        CREATE: `${V1}/support/tickets`,
        DETAIL: (ticketNumber) => `${V1}/support/tickets/${ticketNumber}`,
        ADD_MESSAGE: (ticketNumber) => `${V1}/support/tickets/${ticketNumber}/messages`,
        REOPEN: (ticketNumber) => `${V1}/support/tickets/${ticketNumber}/reopen`,
    },
    STORES: {
        NEARBY: `${V1}/stores/nearby`,
        LOCATOR: `${V1}/stores/locator`,
        DELIVERY_PROVIDER: `${V1}/stores/delivery-provider`,
        STOCK_STATUS: (storeId) => `${V1}/stores/${storeId}/stock-status`,
    },
    CONTACT: {
        SUBMIT: `${V1}/contact`,
    },
    BULK_INQUIRY: {
        SUBMIT: `${V1}/bulk-inquiry`,
        ACCEPT_QUOTE: `${V1}/bulk-inquiry/accept-quote`,
        MY_LIST: `${V1}/bulk-inquiry`,
        MY_DETAIL: (inquiryNumber) => `${V1}/bulk-inquiry/${inquiryNumber}`,
        ACCEPT: (inquiryNumber) => `${V1}/bulk-inquiry/${inquiryNumber}/accept`,
    },
    // Public endpoints (no auth required)
    LOCATIONS: {
        COUNTRIES: `${PUBLIC_V1}/countries`,
        STATES: (countryId) => `${PUBLIC_V1}/countries/${countryId}/states`,
        CITIES: (stateId) => `${PUBLIC_V1}/states/${stateId}/cities`,
    },
    VAT: {
        ACTIVE: `${V1}/vat/active`,
    },
    FAQ: `${V1}/faqs`,
    FAQ_GROUPED: `${V1}/faqs/grouped`,
    NAV_MENUS: `${PUBLIC_V1}/public/nav-menus`,
    LOYALTY: {
        WALLET: `${V1}/loyalty/wallet`,
        TRANSACTIONS: `${V1}/loyalty/transactions`,
        ESTIMATE: `${V1}/loyalty/estimate`,
        VALIDATE_REDEEM: `${V1}/loyalty/redeem/validate`,
    },
};
